var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bank",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3426",
    "data-name": "Path 3426",
    d: "M68.064,23.414,38.811,5.2a1.352,1.352,0,0,0-1.428,0L8.129,23.414A1.358,1.358,0,0,0,7.49,24.57v5.277a1.364,1.364,0,0,0,1.36,1.36H67.344a1.364,1.364,0,0,0,1.36-1.36V24.57a1.358,1.358,0,0,0-.639-1.156ZM38.1,26.175a5.644,5.644,0,1,1,5.644-5.644A5.647,5.647,0,0,1,38.1,26.175Z",
    transform: "translate(0.896)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3427",
    "data-name": "Path 3427",
    d: "M40.53,26.27H50.594V47.01H40.53Z",
    transform: "translate(12.791 7.657)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3428",
    "data-name": "Path 3428",
    d: "M26.3,26.27H36.364V47.01H26.3Z",
    transform: "translate(7.668 7.657)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3429",
    "data-name": "Path 3429",
    d: "M12.06,26.27H22.124V47.01H12.06Z",
    transform: "translate(2.542 7.657)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3430",
    "data-name": "Path 3430",
    d: "M73,51.3v6.474a1.364,1.364,0,0,1-1.36,1.36H6.36A1.355,1.355,0,0,1,5,57.773V51.3a1.355,1.355,0,0,1,1.36-1.36H9.624V44.88a1.364,1.364,0,0,1,1.36-1.36H67.016a1.364,1.364,0,0,1,1.36,1.36v5.059H71.64A1.364,1.364,0,0,1,73,51.3Z",
    transform: "translate(0 13.867)",
    fill: "#7dbaab"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.ee1c99ad3b25ae800a293e4623fa224c.svg";
export { ForwardRef as ReactComponent };